module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.products.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    attrs: {
      "value": _vm.tabIndex
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.products.formTabs.productInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.products",
      "hasLabel": true
    }
  }), _vm._v(" "), (_vm.form.productTypeId && _vm.productTypeName !== 'Child') ? _c('v-form', {
    attrs: {
      "form": _vm.productInfoForm,
      "translation": "form.products",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productTypeName === 'Child') ? _c('v-form', {
    attrs: {
      "form": _vm.childProductForm,
      "translation": "form.products",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productTypeName === 'Child') ? _c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "margin-left": "180px"
    },
    attrs: {
      "loading": _vm.loading,
      "disabled": this.form.errors.any()
    },
    on: {
      "click": _vm.createChildProduct
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.next').toUpperCase()))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'products.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-927e71ae","hasScoped":false}!./src/app/pages/withNavigation/products/create/create.html
// module id = 3090
// module chunks = 1